import React, { useState, useEffect } from "react";
import './navbar.css';
import { Link } from 'react-scroll';
import Mail from "../../assets/mail.png"
import Linkedin from "../../assets/linkedin.png"
import Github from "../../assets/github.png"
import Menu from "../../assets/menu.png"

export default function Navbar () {
    const [activeSection, setActiveSection] = useState('');
    const [showMenu, setShowMenu] = useState(false);

    return (
        <nav className="navbar">
            <div className="navbar-name">
                Ruhani Mittal
            </div>
            <div className="desktopMenu">
                <Link activeClass="active" to="Home" spy={true} smooth={true} offset={-100} duration={500} className="desktopMenuListItem" onClick={()=>setShowMenu(false)}>HOME</Link>
                <Link activeClass="active" to="About" spy={true} smooth={true} offset={-100} duration={500} className="desktopMenuListItem" onClick={()=>setShowMenu(false)}>EXPERIENCES</Link>
                <Link activeClass="active" to="skills" spy={true} smooth={true} offset={-100} duration={500} className="desktopMenuListItem" onClick={()=>setShowMenu(false)}>SKILLS</Link>
                <Link activeClass="active" to="Projects" spy={true} smooth={true} offset={-100} duration={500} className="desktopMenuListItem" onClick={()=>setShowMenu(false)}>PROJECTS</Link>
                <Link activeClass="active" to="Contact" spy={true} smooth={true} offset={-100} duration={500} className="desktopMenuListItem" onClick={()=>setShowMenu(false)}>SAY HELLO;)</Link>
            </div>
            <div className="icons">
            <a href="mailto:ruhanimttl@gmail.com">
                <img src={Mail} alt="mail" className="mail"/> 
            </a>
            <a href="https://www.linkedin.com/in/ruhanimittal/">
                <img src={Linkedin} alt="Linkedin" className="linkedin"/>
            </a>
            <a href="https://github.com/RuhaniMittal29">
                <img src={Github} alt="Github" className="github"/>    
            </a>        
            </div>

            <img src={Menu} alt="Menu" className="mobMenu"  onClick={()=>setShowMenu(!showMenu)}/>
            <div className="navMenu" style={{display: showMenu? 'flex':'none'}}>
                <Link activeClass="active" to="Home" spy={true} smooth={true} offset={-100} duration={500} className="listItem" onClick={()=>setShowMenu(false)}>HOME</Link>
                <Link activeClass="active" to="About" spy={true} smooth={true} offset={-50} duration={500} className="listItem" onClick={()=>setShowMenu(false)}>EXPERIENCES</Link>
                <Link activeClass="active" to="skills" spy={true} smooth={true} offset={-50} duration={500} className="listItem" onClick={()=>setShowMenu(false)}>SKILLS</Link>
                <Link activeClass="active" to="Projects" spy={true} smooth={true} offset={-50} duration={500} className="listItem" onClick={()=>setShowMenu(false)}>PROJECTS</Link>
                <Link activeClass="active" to="Contact" spy={true} smooth={true} offset={-50} duration={500} className="listItem" onClick={()=>setShowMenu(false)}>SAY HELLO;)</Link>
            </div>
        </nav>
    )
}